import { isAxiosError } from "axios"

const MAX_RETRIES = 3

/** TanStack Query `retry` option: retries network failures and 5xx responses; a 4xx will fail the same way again. */
export function retryNetworkAndServerErrors(failureCount: number, error: Error): boolean {
  if (failureCount >= MAX_RETRIES || !isAxiosError(error)) return false
  const status = error.response?.status
  return status === undefined || status >= 500
}
